export default state => state.page && state.page.data && state.page.data.blocks;
